<template>
  <div class="orderDetails">
    <van-sticky>
      <div
        class="orderDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">订单详情</span>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="mid">
        <div class="content">
          <div class="contentTop">
            <div class="left">
              <h3>{{ data.status_name }}</h3>
              <p @click="toSubsidyList(data.id)" v-if="data.app_status == 8">
                共{{ data.stages }}期，已补{{ data.total_over_stages }}期<img
                  src="./../../../assets/decoration/rights.png"
                  alt=""
                />
              </p>
              <p
                @click="toMoreDetails()"
                ref="detailDom"
                v-else
                :class="{ unfold: isUnfold }"
              >
                {{ data.tip
                }}<img
                  v-if="!showDetailBtn"
                  src="./../../../assets/decoration/rights.png"
                  alt=""
                />
              </p>
              <div class="rejectReason">
                <div class="tipMore" v-if="showDetailBtn">
                  <span v-if="!isUnfold" @click="isUnfold = true"
                    >展开<img
                      src="./../../../assets/decoration/order/zk.png"
                      alt=""
                  /></span>
                  <span v-if="isUnfold" @click="isUnfold = false"
                    >关闭<img
                      src="./../../../assets/decoration/order/sq.png"
                      alt=""
                  /></span>
                </div>
              </div>
            </div>
            <div
              class="right"
              @click="toMoreDetails()"
              v-if="
                data.order_source &&
                data.order_source != 30 &&
                data.order_source != 40
              "
            >
              <img
                v-if="data.app_status == 1 || data.app_status == 3"
                src="./../../../assets/decoration/order/ws.png"
                alt=""
              />
              <img
                v-if="data.app_status == 6"
                src="./../../../assets/decoration/order/qht.png"
                alt=""
              />
              <img
                v-if="data.app_status == 4 || data.app_status == 10"
                src="./../../../assets/decoration/order/zf.png"
                alt=""
              />
              <button>更多信息</button>
            </div>
          </div>
          <div class="contentMid">
            <div
              class="card"
              v-if="data.app_status == 8"
              :style="{
                paddingBottom: data.is_old_type == 0 ? '12px' : '32px',
              }"
            >
              <div class="topTip" v-if="data.is_old_type == 0">
                <div>
                  <span>装修地址：</span>
                  <span>{{ data.province_city_area }}{{ data.address }}</span>
                </div>
                <div>
                  <span>装修总价：</span>
                  <span>¥{{ data.total_amount }}</span>
                </div>
              </div>
              <div
                class="item"
                :style="{ paddingTop: data.is_old_type == 0 ? '12px' : '32px' }"
              >
                <span>补贴类型</span>
                <span class="blank333" v-if="data.settle_type == 0"
                  >无任何返还</span
                >
                <span class="blank333" v-if="data.settle_type == 1"
                  >消费补贴</span
                >
                <span class="blank333" v-if="data.settle_type == 2"
                  >积分赠送</span
                >
              </div>
              <div class="item">
                <span>申请数额</span>
                <span class="blank333">¥{{ data.amount }}</span>
              </div>
              <div class="divider" v-if="data.is_old_type == 0"></div>
              <div class="item" v-if="data.is_old_type == 0">
                <span>实付款：</span>
                <span class="red">¥{{ data.pay_amount }}</span>
              </div>
            </div>
            <div class="card" style="padding-bottom: 24px">
              <h3>订单详情</h3>
              <div class="item">
                <span>订单编号</span>
                <span class="blank333">
                  <img
                    @click="copy()"
                    id="copycode"
                    :data-clipboard-text="data.order_sn"
                    src="./../../../assets/decoration/copy.png"
                    alt=""
                  />{{ data.order_sn }}</span
                >
              </div>
              <div class="item">
                <span>下单时间</span>
                <span class="blank333">{{
                  data.is_old_type == 0
                    ? data.created_at
                    : data.first_stage_time
                }}</span>
              </div>
              <div
                class="item"
                v-if="data.is_old_type == 0 && data.app_status == 8"
              >
                <span>支付时间</span>
                <span class="blank333">{{ data.pay_time }}</span>
              </div>
              <div
                class="item"
                v-if="data.is_old_type == 0 && data.app_status == 8"
              >
                <span>完成时间</span>
                <span class="blank333">{{ data.judge_time }}</span>
              </div>
              <div class="item" v-if="data.app_status != 8">
                <span>补贴类型</span>
                <span class="blank333">{{ data.settle_type_name }}</span>
              </div>
            </div>
            <div
              class="card"
              style="padding-bottom: 24px"
              v-if="data.app_status == 8"
              @click="toSubsidyList(data.id)"
            >
              <h3>
                <span>
                  <img
                    src="./../../../assets/decoration/hb.png"
                    alt=""
                  />每期记录
                </span>
                <img src="./../../../assets/decoration/right.png" alt="" />
              </h3>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 取消订单按钮 -->
    <div class="cancelBtm" v-if="data.has_cancel">
      <span @click="cancelOrder()">取消订单</span>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      isiOSX: false,
      id: null,
      data: {},
      isToken: false,
      showDetailBtn: false,
      isUnfold: false,
      isLoading: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
      this.isToken = true;
    } else {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.isToken = false;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      if (this.isToken) {
        this.params("", "", "goBack");
      } else {
        this.$router.go(-1);
      }
    },
    showDetailBtnFun() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.detailDom = this.$refs.detailDom;
          if (this.detailDom) {
            this.showDetailBtn =
              this.detailDom.clientHeight < this.detailDom.scrollHeight;
          }
        }, 100);
      });
    },
    onRefresh() {
      this.getData();
    },
    // 获取订单详情
    getData() {
      this.$api
        .post("decoration/member/order/show", {
          order_id: this.id,
        })
        .then((res) => {
          // console.log(res);
          this.data = res;
          this.showDetailBtnFun();
          this.isLoading = false;
        });
    },
    // 跳转补贴记录
    toSubsidyList(id) {
      this.$router.push({
        path: "/decoration/order/subsidyList",
        query: {
          id: id,
        },
      });
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 取消订单
    cancelOrder() {
      this.$dialog
        .confirm({
          title: "确认取消订单？",
          message: "点击确定后，该订单将关闭",
          width: "280px",
          confirmButtonColor: "#5853E9",
          cancelButtonColor: "rgba(88, 83, 233, .1)",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          theme: "round-button",
        })
        .then(() => {
          this.$api.get("decoration/basic/csrf/token").then((res) => {
            this.$api
              .post("decoration/member/order/cancel", {
                order_id: this.id,
                csrf_token: res.csrf_token,
              })
              .then((res) => {
                this.getData();
              });
          });
        })
        .catch(() => {});
    },
    toMoreDetails() {
      this.$router.push({
        path: "/decoration/order/moreDetails",
        query: {
          id: this.id,
          allComplete:
            this.data.app_status == 8 || this.data.app_status == 5
              ? true
              : false,
          judge_remark: this.data.app_status == 5 ? this.data.tip : null,
          order_sn: this.data.order_sn,
          order_status: this.data.app_status,
        },
      });
    },
  },
};
</script>
<style lang="less">
.orderDetails {
  min-height: 100%;
  background: #f5f6ff;
  .orderDetailsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .mid {
    .content {
      width: 100%;
      .contentTop {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        padding: 24px 0 105px;
        background: linear-gradient(135deg, #918bf6 0%, #5853e9 100%);
        .left {
          max-width: 72%;
          h3 {
            font-size: 24px;
            color: #ffffff;
            margin: 8px 16px 12px;
          }
          p {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #ffffff;
            margin: 0 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            text-align: justify;
            img {
              width: 12px;
              height: 12px;
            }
          }
          .unfold {
            -webkit-line-clamp: 99;
          }
          .rejectReason {
            padding: 10px 16px;
            color: #ffffff;
            .tipMore {
              display: flex;
              span {
                font-size: 14px;
                display: flex;
                align-items: center;
                img {
                  width: 12px;
                  height: 12px;
                  margin-left: 2px;
                }
              }
            }
          }
        }
        .right {
          position: relative;
          margin-top: 24px;
          img {
            height: 23px;
            position: absolute;
            top: -15px;
            left: 50%;
            transform: translateX(-50%);
          }
          button {
            height: 30px;
            background: rgba(255, 255, 255, 0.6);
            border-radius: 100px 0px 0px 100px;
            border: none;
            padding: 0 16px;
            font-size: 13px;
            font-weight: 400;
            color: #605beb;
          }
        }
      }
      .contentMid {
        position: relative;
        top: -89px;
        .card {
          margin: 0 16px 16px;
          padding: 1px 16px;
          background: #ffffff;
          border-radius: 12px;
          .topTip {
            //   background: #f5f6ff;
            border-radius: 8px;
            padding: 6px 12px 12px 20px;
            position: relative;
            margin: 19px 0 10px;
            background: url("./../../../assets/decoration/orderxq.png") #f5f6ff
              no-repeat;
            background-size: 100px 72px;
            background-position: right bottom;
            div {
              display: flex;
              span {
                font-size: 13px;
                color: #666666;
                line-height: 24px;
                margin: 6px 0 0;
              }
              span:first-child {
                flex-shrink: 0;
              }
            }
          }
          h3 {
            font-size: 15px;
            color: #333333;
            line-height: 21px;
            margin: 23px 0 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              display: flex;
              align-items: center;
              img {
                width: 24px;
                height: 24px;
              }
            }
            img {
              width: 16px;
              height: 16px;
            }
          }
          .divider {
            height: 1px;
            background-color: #f0f1ff;
            margin: 22px 0 2px;
          }
          .item {
            display: flex;
            justify-content: space-between;
            padding-top: 12px;
            span {
              font-size: 14px;
              color: #666666;
              line-height: 20px;
              display: flex;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
            }
            .blank333 {
              color: #333333;
            }
            .red {
              font-size: 15px;
              font-weight: 700;
              color: #e90e45;
            }
          }
        }
      }
    }
  }
  .cancelBtm {
    height: 83px;
    width: 100%;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px #f7f8fc;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    span {
      height: 36px;
      line-height: 36px;
      border-radius: 20px;
      border: 1px solid #eeeeee;
      font-size: 14px;
      color: #333333;
      padding: 0px 24px;
      margin: 7px 16px 0 0;
    }
  }
}
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel {
  color: #5853e9 !important;
}
</style>